import * as React from 'react';

import { ITermsOfUseCardAcceptanceProps } from '../models/types';
import { TermsOfUseCardExpanded } from './TermsOfUseCardExpanded';
import { useGetPolicyFileDataAuthenticated } from '../hooks/useGetPolicyFileData';
import { useGetRegionalAndLanguageSettingsQuery } from '../../Language/hooks/useGetRegionalAndLanguageSettingQuery';

export const TermsOfUseCardExpandedAuth: React.FC<ITermsOfUseCardAcceptanceProps> = (props) => {
  const getPolicyFileDataQuery = useGetPolicyFileDataAuthenticated(props.agreementId, props.policyFileId);
  const getRegionalAndLanguageSettingsQuery = useGetRegionalAndLanguageSettingsQuery();

  return (
    <TermsOfUseCardExpanded
      getPolicyFileDataQuery={getPolicyFileDataQuery}
      getRegionalAndLanguageSettingsQuery={getRegionalAndLanguageSettingsQuery}
      {...props}
    />
  );
};
